import { render } from "./Bm.vue?vue&type=template&id=cf245040&scoped=true"
import script from "./Bm.vue?vue&type=script&lang=js"
export * from "./Bm.vue?vue&type=script&lang=js"

import "./Bm.vue?vue&type=style&index=0&id=cf245040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf245040"]])

export default __exports__